import Cards from "../components/Cards";

const ContentLanding = () => {
  return <Cards />;
};

export default ContentLanding;
